import {AssignedDesks} from "../../../api/AssignedDeskStore";
import {EmployeeVisitSheet} from "../../../api/EmployeeVisitStore";
import {isAssigned, Neighbourhood} from "../../../api/Model";
import {DateRangeOption} from "../../../components/filter-fields/DateRangeFilter";
import {assignedDeskCriteria} from "../../../components/visit-stat-block/AssignedDeskCriteria";
import {
    calculateVisitWithAssignedDesksStatistics,
    VisitWithAssignedDesksStats,
} from "../../../components/visit-stat-block/OfficeVisitStats";
import {combineCmp, numberCmp, stringCmp} from "../../../util/SortUtil";

export type AbandonedNeighbourhood = {
    neighbourhood: Neighbourhood;
    actual: VisitWithAssignedDesksStats;
};

export function findAbandonedNeighbourhoods(
    employeeVisits: EmployeeVisitSheet,
    assignedDesks: AssignedDesks,
    neighbourhoods: Neighbourhood[],
    dateRange: DateRangeOption,
): AbandonedNeighbourhood[] {
    return neighbourhoods
        .filter(neighbourhood => isAssigned(neighbourhood) && neighbourhood.employees.length > 0)
        .map(neighbourhood => ({
            neighbourhood,
            actual: calculateVisitWithAssignedDesksStatistics(
                employeeVisits,
                neighbourhood.employees,
                assignedDesks,
                assignedDeskCriteria['100'],
                dateRange,
                neighbourhood.desks.length,
            ),
        }))
        .filter(({actual}) => actual.median.percent <= 40)
        .sort(combineCmp(
            numberCmp(({actual}) => actual.median.percent),
            stringCmp(({neighbourhood}) => neighbourhood.name),
        ));
}
